import Vue from "vue";
import VueRouter from "vue-router";
import AboutPage from "@/views/AboutPage/AboutPage.vue";
import CareerPage from "@/views/CareerPage/CareerPage.vue";
import SkillsAndToolsPage from "@/views/SkillsAndToolsPage/SkillsAndToolsPage.vue";
import ContactPage from "@/views/ContactPage/ContactPage.vue";
import MainPage from "@/views/MainPage/MainPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: MainPage,
    redirect: { name: "About" },
    children: [
      {
        path: "about",
        name: "About",
        meta: { title: "About" },
        component: AboutPage,
      },
      {
        path: "skillsAndTools",
        name: "SkillsAndTools",
        meta: { title: "Skills And Tools" },
        component: SkillsAndToolsPage,
      },
      {
        path: "career",
        name: "Career",
        meta: { title: "Career" },
        component: CareerPage,
      },
      {
        path: "contact",
        name: "Contact",
        meta: { title: "Contact" },
        component: ContactPage,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
